import React from 'react'

export const IconBack = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.69329 10.8334L10.9374 16.0775L9.75885 17.256L2.50293 10.0001L9.75885 2.74414L10.9374 3.92265L5.69329 9.16673H17.8481V10.8334H5.69329Z"
        fill="#878696"
      />
    </svg>
  )
}
